import Row from "../../../../../../../components/tag/Row";
import Span from "../../../../../../../components/tag/Span";
import {navigateToReschedule, showRescheduleTransitionModal} from "../../../../../../timeline/data/actions";
import {FormattedMessage} from "react-intl";
import React, {useContext} from "react";
import {TimelineFrameDataContext} from "../../../../../TimelineFramePage";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {OTLink} from "../../../../../../../components/tag/OTLink";
import {TimelineFrameCareUnitContext} from "../../careunitdetails/TimelineFrameContentCareUnitWrapper";


const TimelineFrameContentCanBeRescheduled = ({history, showRescheduleTransitionModal, navigateToReschedule}) => {
    const { data } = useContext(TimelineFrameDataContext);
    if(data.canBeRescheduled) {
        return (
            <>
                <Row>
                    <Span>
                        <i className="card-icon icon-calendar"/>{' '}
                        <button
                            className="card-link"
                            onClick={() => {
                                if (data.canBeRescheduled === 'CAN_RESCHEDULE_ONCE') {
                                    showRescheduleTransitionModal(data.id);
                                } else if (data.canBeRescheduled === 'CAN_RESCHEDULE_MULTIPLE') {
                                    navigateToReschedule(data.id, history);
                                }
                            }}>
                            <FormattedMessage id={'move.time'}/>
                        </button>
                    </Span>
                </Row>
            </>
        );
    }
    return null;
}

const mapDispatchToProps = (dispatch) => {
    return {
        showRescheduleTransitionModal: (id) =>
            dispatch(showRescheduleTransitionModal(id)),
        navigateToReschedule: (id, history) =>
            dispatch(navigateToReschedule(id, history))
    }
}

export default withRouter(connect(null, mapDispatchToProps)(TimelineFrameContentCanBeRescheduled));